import React, {Suspense, lazy} from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import Loader from "./components/Loader/Loader";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import './assets/scss/style.scss'

// Routes
const Landing = lazy(() => import('./views/Landing/Landing'));

const Register = lazy(() => import('./views/Auth/Register/Register'));
const Login = lazy(() => import('./views/Auth/Login/Login'));

const About = lazy(() => import('./views/About/About'));
const Contact = lazy(() => import('./views/Contact/Contact'));
const PrivacyPolicy = lazy(() => import('./views/PrivacyPolicy/PrivacyPolicy'));
const Tos = lazy(() => import('./views/ToS/ToS'));

const Dashboard = lazy(() => import('./views/Dashboard/Dashboard'));

const UpdateEvent = lazy(() => import('./views/UpdateEvent/UpdateEvent'));
const EventInfo = lazy(() => import('./views/EventInfo/EventInfo'));
const CreateEvent = lazy(() => import('./views/CreateEvent/CreateEvent'));

const CompanyProfile = lazy(() => import('./views/CompanyProfile/CompanyProfile'));
const CompanyTeam = lazy(() => import('./views/CompanyTeam/CompanyTeam'));
const CompanyBilling = lazy(() => import('./views/CompanyBilling/CompanyBilling'));
const Company = lazy(() => import('./views/Admin/Company/Company'));
const CreateCompany = lazy(() => import('./views/Admin/CreateCompany/CreateCompany'));
const CompanyEvents = lazy(() => import('./views/Admin/CompanyEvents/CompanyEvents'));
const CompanyTeamAdmin = lazy(() => import('./views/Admin/CompanyTeam/CompanyTeam'));
const CompanyBillingAdmin = lazy(() => import('./views/Admin/CompanyBilling/CompanyBilling'));
const CompanyAnalytics = lazy(() => import('./views/Admin/CompanyAnalytics/CompanyAnalytics'));
const CreateCompanyEvent = lazy(() => import('./views/Admin/CreateCompanyEvent/CreateCompanyEvent'));
const UpdateCompanyEvent = lazy(() => import('./views/Admin/UpdateCompanyEvent/UpdateCompanyEvent'));
const Requests = lazy(() => import('./views/Admin/Requests/Requests'));
const CompanyRequest = lazy(() => import('./views/Admin/CompanyRequest/CompanyRequest'));
const Notifications = lazy(() => import('./views/Admin/Notifications/Notifications'));
const FeaturedEvents = lazy(() => import('./views/Admin/FeaturedEvents/FeaturedEvents'));

const UserProfile = lazy(() => import('./views/UserProfile/UserProfile'));
const Page404 = lazy(() => import('./views/Page404/Page404'));
const QrCode = lazy(() => import('./views/Page404/QrCode'))

const Analytics = lazy(() => import('./views/Analytics/Analytics'));
const EventAnalytics = lazy(() => import('./views/Analytics/Event/Event'));


function App() {
    return (
        <div className="App h-screen">

            <Suspense fallback={<Loader className='mt-6 text-orange-900'/>}>
                <Router>
                    <Switch>
                        <Route exact path='/' component={Landing}/>
                        <Route exact path='/register' component={Register}/>
                        <Route exact path='/login' component={Login}/>
                        <Route exact path='/about' component={About}/>
                        <Route exact path='/contact' component={Contact}/>
                        <Route exact path='/privacy-policy' component={PrivacyPolicy}/>
                        <Route exact path='/terms-of-service' component={Tos}/>
                        <ProtectedRoute exact path='/dashboard' component={Dashboard}/>
                        <ProtectedRoute exact path='/dashboard/companies/create' component={CreateCompany}/>
                        <ProtectedRoute exact path='/dashboard/companies/team/:id' component={CompanyTeamAdmin}/>
                        <ProtectedRoute exact path='/dashboard/companies/billing/:id' component={CompanyBillingAdmin}/>
                        <ProtectedRoute exact path='/dashboard/companies/analytics/:id' component={CompanyAnalytics}/>
                        <ProtectedRoute exact path='/dashboard/companies/:id' component={Company}/>
                        <ProtectedRoute exact path='/dashboard/companies/events/:id' component={CompanyEvents}/>
                        <ProtectedRoute exact path='/dashboard/companies/:id/events/create'
                                        component={CreateCompanyEvent}/>
                        <ProtectedRoute exact path='/dashboard/companies/:id/events/update/:eventId'
                                        component={UpdateCompanyEvent}/>
                        <ProtectedRoute exact path='/dashboard/requests' component={Requests}/>
                        <ProtectedRoute exact path='/dashboard/requests/:id' component={CompanyRequest}/>
                        <ProtectedRoute exact path='/dashboard/notifications' component={Notifications}/>
                        <ProtectedRoute exact path='/dashboard/featured-events' component={FeaturedEvents}/>
                        <ProtectedRoute exact path='/dashboard/analytics' component={Analytics}/>
                        <ProtectedRoute exact path='/dashboard/analytics/:id' component={EventAnalytics}/>
                        <ProtectedRoute exact path='/dashboard/profile' component={CompanyProfile}/>
                        <ProtectedRoute exact path='/dashboard/team' component={CompanyTeam}/>
                        <ProtectedRoute exact path='/dashboard/billing' component={CompanyBilling}/>
                        <ProtectedRoute exact path='/dashboard/event/:id' component={EventInfo}/>
                        <ProtectedRoute exact path='/dashboard/update-event/:id' component={UpdateEvent}/>
                        <ProtectedRoute exact path='/dashboard/create-event' component={CreateEvent}/>
                        <ProtectedRoute exact path='/dashboard/user-profile' component={UserProfile}/>

                        <Route exact path='/events' component={QrCode}/>
                        <Route component={Page404}/>
                    </Switch>
                </Router>
            </Suspense>
        </div>
    );
}

export default App;
